import { Component, h, Host, Prop, State, Method, Listen, Element } from '@stencil/core';
import { $$$ } from '../../../utils/utils';
import axios from '../../../utils/get-axios';
import { LiluQuantityButton } from '../lilu-quantity-button/lilu-quantity-button';
import { TealiumAddRemoveEvent } from '../../../utils/tealium/TealiumAddRemoveEvent';
import { LiluQuantitySelector } from '../../01_atoms/lilu-quantity-selector/lilu-quantity-selector';

const ACC = (window as any).ACC;
@Component({
  tag: 'lilu-mini-basket',
  styleUrl: 'lilu-mini-basket.scss',
  shadow: true,
})
export class LiluMiniBasket {
  @Prop() currentcount = 0;
  @Prop() basketelement = '';
  @Prop() liluMiniBaseketFlyOutelement = '';
  @Prop() timeout: any;
  @Prop() quantityButtons: any[] = [];
  @Prop() CSRFToken?: any;

  @Prop() heading = '';
  @State() open = false;
  @State() isBodyAtTop = true;

  @Element() element: HTMLElement;

  tokenHeader: any = null;
  modal: any;
  modalContent: any;

  @Listen('scroll', { target: 'window' })
  onScroll() {
    this.isBodyAtTop = window.scrollY === 0;
  }

  @Listen('productChange', { target: 'body' })
  handleOldFurnitureDisposal(event: any) {
    this.addFurnitureDisposalToBasket(event.detail.url, event.detail.interruptUrl,event.detail.storeId, event.detail.productId, event.detail.quantity);
  }

  private toggleMiniBasket() {
    this.open = !this.open;

    if (!this.open) {
      for (let item of this.quantityButtons) {
        if (typeof item !== 'undefined' && typeof item.basketId !== 'undefined') {
          this.unregisterAddToCartButton(item.basketId);
        }
      }
    }
  }

  getBasket: any = () => {
    return <div innerHTML={this.basketelement}></div>;
  };

  openModal(html: string) {
    this.modal = document.querySelector(`[data-modal="default"]`);
    this.modalContent = document.querySelector(`[data-modal="default"] .content`);
    this.modalContent.innerHTML = html;
    this.modal.open();
  }

  getQuantityFromURL(url: string): number {
    let quantity = 1;
    if (url.includes('-')) {
      const numberFromURL = url.substring(url.indexOf('-') + 1, url.lastIndexOf('/'));
      try {
        quantity = Number(numberFromURL);
      } catch (err) {
        console.error(err);
      }
    }

    return quantity;
  }

  getInterruptContent(url) {
  axios
    .post(url, '', this.tokenHeader)
    .then(response => {
      this.openModal(response.data.content);
    })
    .catch(function (error) {
      console.error(error);
    });
  }

  @Method()
  async addAxiosCall(url, productId, quantity, productAddedCallback, addErrorCallback) {
    axios
      .post(url, '', this.tokenHeader)
      .then(response => {
        if (response.data.modal && response.data.modal.html !== '') {
          this.openModal(response.data.modal.html);
        }

        const modalContent = response.data.modal ? response.data.modal.html : response.data.liluMiniBaseketFlyOutMini;

        if (modalContent) {
          this.openModal(modalContent);
        }

        this.updateMiniBasketHTML(response);

        new TealiumAddRemoveEvent(productId.toString(), 0, quantity).link();

        productAddedCallback({ productId: response.data.items[0].id, success: response.data.success });
      })
      .catch(error => {
        addErrorCallback(error);
      });
  }

  @Method()
  async addFurnitureDisposalToBasket(url: string, interruptUrl: string, storeId: string, productId: number, quantity: number, productAddedCallback = _ => {}, addErrorCallback = _ => {}) {
    if (typeof interruptUrl === 'string' && interruptUrl) {
      url = interruptUrl;
      this.getInterruptContent(url);
    } else {
      url = `${url}/${storeId}/${productId}-${quantity}`;
      await this.addAxiosCall(url, productId, quantity, productAddedCallback, addErrorCallback);
    }
  }

  @Method()
  async addProductToBasket(url, productId, storeId, productAddedCallback = _ => {}, addErrorCallback = _ => {}) {
    this.currentcount++;
    let urlSuffix = '';
    if (storeId) {
      urlSuffix += `${storeId}/`;
    }
    if (productId) {
      urlSuffix += `${productId}/`;
    }

    if (urlSuffix.length === 0) {
      console.error('addProductToBasket no urlSuffix');
      return;
    }

    url = `${url}/add/${urlSuffix}`;
    url = url.replace('//', '/');

    const quantity = this.getQuantityFromURL(url);

    await this.addAxiosCall(url, productId, quantity, productAddedCallback, addErrorCallback);
  }

  @Method()
  async updateProductFromBasket(url: string, interruptUrl: string, productId: number, quantity: number, cartUpdatedCallback = _ => {}, updateErrorCallback = _ => {}) {
    if(typeof interruptUrl === 'string' && interruptUrl) {
      url = interruptUrl;
      this.getInterruptContent(url);
    } else {
      url = `${url}/update/${productId}/${quantity}`;
      this.setPDPBtnsLoading(true);
      axios
        .post(url, '', this.tokenHeader)
        .then(response => {
          if (response.data.modal && response.data.modal.html !== '') {
            this.openModal(response.data.modal.html);
          }
          if (response.data.items) {
            const productId = response.data.items[0].id;
            cartUpdatedCallback({ productId: productId, success: response.data.success });
            if (response.data.items[0].qty === '0') {
              const quantityBtn: LiluQuantityButton = document.querySelector(`lilu-quantity-button[uid="${productId}"]`) as any;
              if (quantityBtn) {
                quantityBtn?.setAmount(0, false); // false avoids duplicate server request on the quantityBtn
              } else {
                const quantitySelector: LiluQuantitySelector = $$$(`lilu-quantity-selector[product-id="${productId}"]`)[0];
                if (quantitySelector) {
                  quantitySelector.triggerTealiumAddRemoveEvent(0);
                } else {
                  this.linkTealiumAddRemoveEvent(productId, quantity); // no event was triggered by any quantityBtn. We need to trigger it here.
                }
              }
            }
          }
          this.updateMiniBasketHTML(response);
        })
        .catch(error => {
          console.error('updateProductFromBasket axios error', error);
          updateErrorCallback(error);
        })
        .finally(() => {
          this.setPDPBtnsLoading(false);
        });
    }
  }

  @Method()
  async changeProductFromBasket(url: string, interruptUrl: string, cartChangeCallback = _ => {}, changeErrorCallback = _ => {}) {
    if(typeof interruptUrl === 'string' && interruptUrl) {
      url = interruptUrl;
      this.getInterruptContent(url);
    } else {
    axios
      .post(url, '', this.tokenHeader)
      .then(response => {
        this.updateMiniBasketHTML(response);
        if (response.data.items) {
          cartChangeCallback(response.data.items[0].id);
          if (response.data.items[0].qty === '0') {
            document.querySelector(`lilu-quantity-button[uid="${response.data.items[0].id}"]`)?.setAttribute('amount', response.data.items[0].qty);
          }
        }
      })
      .catch(error => {
        console.error('changeProductFromBasket axios error', error);
        changeErrorCallback(error);
      });
    }
  }

  @Method()
  async registerAddToCartButton(button) {
    this.quantityButtons.push(button);
    return this.quantityButtons.length - 1;
  }

  @Method()
  async unregisterAddToCartButton(id) {
    delete this.quantityButtons[id];
  }

  setPDPBtnsLoading(isLoading: boolean) {
    const btnToUpdate = $$$('lilu-quantity-button').concat($$$('.cta > lilu-button'));

    btnToUpdate.forEach(element => {
      element.setIsLoading(isLoading);
    });
  }

  getProductQuantity(productId: number): number {
    const basketElement = document.createElement('div');
    basketElement.innerHTML = this.element.getAttribute('basketelement');
    const iconSelector = `lilu-icon[data-id="${productId}"]`;
    const icon = basketElement.querySelector(iconSelector);

    if (icon) {
      const productCount = icon.parentNode.querySelector('p.mini-basket-product-count');
      const counterQuantityText = productCount.textContent.substring(0, productCount.textContent.indexOf(' ')).trim();
      return Number(counterQuantityText);
    } else {
      return -1;
    }
  }

  linkTealiumAddRemoveEvent(productId: number, quantity: number) {
    const oldQuantity = this.getProductQuantity(productId);
    const tealiumAddRemoveEvent = new TealiumAddRemoveEvent(productId.toString(), oldQuantity, quantity);
    tealiumAddRemoveEvent.link();
  }

  // --------------------------------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  async updateBtnAmountAndId(itemInResponse, selector: string) {
    // IS THIS FUNCTION NEEDED?
    if (itemInResponse?.uid) {
      // update the data of the btn
      const button = document.querySelector(selector);
      if (button) {
        button.setAttribute('amount', itemInResponse.quantity);
        button.setAttribute('uid', itemInResponse.uid);
      }
    }
  }

  async updateMiniBasketHTML(response) {
    const minibasketHTML = response.data.liluMiniBaseketFlyOut;
    this.basketelement = minibasketHTML;
    this.currentcount = response.data.liluItemCount;

    const warenkorbElement = $$$('lilu-checkout-warenkorb-wrapper')[0];

    if (warenkorbElement) {
      warenkorbElement.changeBasketContentFromOutside(response);
    }

    this.updateBtnAmountAndId(response.data.deliveryItem, 'lilu-tabs > lilu-quantity-button#deliver-button');
    this.updateBtnAmountAndId(response.data.pickUpItem, 'lilu-tabs > lilu-quantity-button#pickup-button');
  }

  // --------------------------------------------------------------------------------------------
  // --------------------------------------------------------------------------------------------

  onRemoveClickHandlerBindArray = new Array();

  componentDidUpdate() {
    const remove: HTMLElement[] = $$$('.remove-item');
    remove.forEach(item => {
      if (!item.getAttribute('clickable')) {
        const onRemoveClickHandlerBind = this.onRemoveClickHandler.bind(this, item);
        this.onRemoveClickHandlerBindArray.push(onRemoveClickHandlerBind);
        this.onRemoveClickHandlerBindArray.forEach(onRemoveClickHandlerBindEvent => item.removeEventListener('click', onRemoveClickHandlerBindEvent));
        item.addEventListener('click', onRemoveClickHandlerBind, false);
      }
    });
  }

  onRemoveClickHandler(item: HTMLElement) {
    this.updateProductFromBasket(`${this.getCartURL()}/detail`,'' , parseInt(item.getAttribute('data-id')), 0);
  }

  getCartURL(): string {
    return `/${document.documentElement.lang}/cart`;
  }

  componentDidLoad() {
    if (ACC !== undefined) {
      this.tokenHeader = {
        headers: { CSRFToken: ACC.config.CSRFToken },
      };
    }

    $$$('body')[0].addEventListener('click', event => {
      if (this.open) {
        const isClickInside = $$$('lilu-mini-basket')[0].contains(event.target);

        if (!isClickInside) {
          this.toggleMiniBasket();
        }
      }
    });
  }

  render() {
    return (
      <Host>
        <div
          class={`mini-basket-container ${!this.isBodyAtTop ? 'small-header' : ''} ${this.open ? 'open' : ''}`}
          onMouseOver={() => {
            this.open = true;
          }}
          onMouseOut={() => {
            this.open = false;
          }}
        >
          <lilu-link
            class="desktop-basket"
            color="dark"
            appearance="uppercase font-minus-4"
            icon={this.currentcount < 1 ? 'icon-cart' : ' icon-cart-filled'}
            link={this.getCartURL()}
            target="_self"
            size="size-18"
            font="bold"
          >
            {this.currentcount > 0 ? this.currentcount : ''} {this.heading.toUpperCase()}
          </lilu-link>
          <lilu-link
            class="mobile-basket"
            color="dark"
            appearance="uppercase font-minus-4"
            icon={this.currentcount < 1 ? 'icon-cart' : ' icon-cart-filled'}
            link={this.getCartURL()}
            target="_self"
            size="size-16"
            font="bold"
          >
            {this.currentcount > 0 ? this.currentcount : ''}
          </lilu-link>
          <div class="basket-content">{this.open && this.currentcount > 0 ? this.getBasket() : null}</div>
        </div>
      </Host>
    );
  }
}
